import { Directive, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { TSFixme } from '@models/TSFixme';

import { environment } from '../../environments/environment';

@Directive({
	selector: '[qeHideProd]',
})
export class HideProdDirective implements OnInit {

	constructor(
		private readonly templateRef: TemplateRef<TSFixme>,
		private readonly viewContainerRef: ViewContainerRef,
	) { }

	ngOnInit(): void {
		if (!environment.production) {
			this.viewContainerRef.createEmbeddedView(this.templateRef);
		}
	}

}
